import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { s as styles } from '../audio.rtlignore-fad433f7.js';
import { getAudioSrc } from '../consts.js';
import { ROOT } from '../dataHooks.js';
import ReactPlayerWrapper from '../ReactPlayerWrapper.js';
import AudioEmbedViewer from './audio-embed-viewer.js';
import '../style-inject.es-e7b07dd7.js';
import 'ricos-types';
import 'classnames';
import 'lodash';
import 'wix-react-player';
import 'wix-rich-content-ui-components';
import '../components/AudioImage.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../components/AudioDetails.js';
import '../components/AudioActionIcons.js';
import 'ricos-content';
import '../components/SoundControl.js';
import '../components/ContextMenu.js';
import 'wix-rich-content-editor-common';
import '../components/DropdownMenu.js';
import '../components/AudioDuration.js';
import 'wix-rich-content-common';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const AudioViewer = ({
  settings,
  disabled,
  componentData,
  isLoading,
  updateAttributes,
  nodeId
}) => {
  var _a;
  const { isMobile } = useContext(RicosContext);
  const { audio = {}, authorName, name, coverImage, disableDownload } = componentData || {};
  const url = getAudioSrc(audio == null ? void 0 : audio.src, settings);
  const shouldEmbed = componentData == null ? void 0 : componentData.html;
  const saveDurationToData = (duration) => updateAttributes == null ? void 0 : updateAttributes({ audio: __spreadProps(__spreadValues({}, audio), { duration }) });
  return /* @__PURE__ */ React.createElement("div", { className: styles.container, "data-hook": ROOT }, !shouldEmbed ? /* @__PURE__ */ React.createElement(
    ReactPlayerWrapper,
    {
      url,
      name,
      authorName,
      coverImage: { src: coverImage == null ? void 0 : coverImage.src.id },
      disableDownload,
      helpers: {},
      isMobile,
      showControls: !!((_a = audio == null ? void 0 : audio.src) == null ? void 0 : _a.url),
      disabled,
      isLoading,
      saveDurationToData,
      isDownloadDisabled: settings == null ? void 0 : settings.disableDownload
    }
  ) : /* @__PURE__ */ React.createElement(AudioEmbedViewer, { componentData, settings, nodeId }));
};

export { AudioViewer as default };
//# sourceMappingURL=audio-viewer.js.map
